import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-37f77c21"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex grow align-center justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "flex col g24"
}
const _hoisted_3 = { class: "flex justify-between grow align-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = { class: "flex align-center" }
const _hoisted_6 = { class: "grid single" }
const _hoisted_7 = { class: "class flex text-muted no-mobile" }
const _hoisted_8 = { class: "flex grow justify-between" }
const _hoisted_9 = { class: "flex align-center justify-end grow" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "flex align-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Ajouter", -1))
const _hoisted_13 = {
  class: "flex col g24",
  style: {"width":"450px","min-height":"400px"}
}
const _hoisted_14 = {
  key: 0,
  class: "flex col g24 align-center",
  style: {"min-height":"280px"}
}
const _hoisted_15 = { class: "pin-input" }
const _hoisted_16 = ["onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_17 = {
  class: "flex col g24 align-center",
  style: {"min-height":"280px"}
}
const _hoisted_18 = { class: "pattern-grid" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "pattern-point-order"
}
const _hoisted_21 = { class: "flex justify-end g10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeLoadingIndicator = _resolveComponent("SeLoadingIndicator")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeIllustration = _resolveComponent("SeIllustration")!
  const _component_SeEditableText = _resolveComponent("SeEditableText")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_SeTab = _resolveComponent("SeTab")!
  const _component_SeModal = _resolveComponent("SeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_SeLoadingIndicator)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ToggleSwitch, {
                modelValue: _ctx.state.displayUnactives,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.displayUnactives) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("display-unactives")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_SeButton, {
                ref: "modifyBtn",
                onPress: _ctx.saveEmployees,
                icon: "/ico/save.svg",
                tooltip: _ctx.Lang.getI18N('save')
              }, null, 8, ["onPress", "tooltip"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.employees, (employee) => {
              return _withDirectives((_openBlock(), _createBlock(_component_WideCard, {
                active: employee.active
              }, {
                subtitle: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_SeIllustration, {
                      onFilePick: (a, b) => _ctx.onEmployeeIllustrationChange(a, b, employee),
                      src: 
                employee.illustration_url
                  ? employee.illustration_url.get()
                  : '/ico/account.svg'
              ,
                      size: 24
                    }, null, 8, ["onFilePick", "src"]),
                    _createVNode(_component_SeEditableText, {
                      modelValue: employee.name,
                      "onUpdate:modelValue": ($event: any) => ((employee.name) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_SeEditableText, {
                      modelValue: employee.surname,
                      "onUpdate:modelValue": ($event: any) => ((employee.surname) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                body: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_SeDropdown, {
                        titleFunc: (roleRef) => _ctx.state.getRoleName(roleRef),
                        modelValue: employee.role,
                        "onUpdate:modelValue": ($event: any) => ((employee.role) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.roles.map((x) => x.ref), (role) => {
                            return (_openBlock(), _createBlock(_component_SeDropdownItem, { value: role }, null, 8, ["value"]))
                          }), 256))
                        ]),
                        _: 2
                      }, 1032, ["titleFunc", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_SeButton, {
                        onClick: ($event: any) => (_ctx.openAuthModal(employee)),
                        tooltip: _ctx.Lang.getI18N('edit-auth')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("password")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "tooltip"]),
                      _createVNode(_component_ToggleSwitch, {
                        modelValue: employee.active,
                        "onUpdate:modelValue": ($event: any) => ((employee.active) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["active"])), [
                [_vShow, _ctx.state.displayUnactives || employee.active]
              ])
            }), 256)),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addEmployee && _ctx.addEmployee(...args))),
              class: "flex justify-center align-center employee-card"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_SeImage, { src: "ico/plus-blue.svg" })
              ])
            ])
          ])
        ])),
    _createVNode(_component_SeModal, {
      ref: "authModal",
      title: _ctx.Lang.getI18N('employee-authentication'),
      class: "auth-modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_SeTab, {
            ref: "authTabComponent",
            tabs: [_ctx.Lang.getI18N('password'), _ctx.Lang.getI18N('pattern')],
            onTabChange: _ctx.onAuthTabChange
          }, {
            "0": _withCtx(() => [
              (_ctx.isUsingPassword)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.Lang.getI18N("enter-4-digit-pin")), 1),
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (digit, index) => {
                        return _withDirectives(_createElementVNode("input", {
                          key: index,
                          type: "text",
                          class: "pin-digit",
                          maxlength: "1",
                          pattern: "[0-9]*",
                          inputmode: "numeric",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.passwordDigits[index]) = $event),
                          onInput: ($event: any) => (_ctx.onPinDigitInput(index)),
                          onKeydown: ($event: any) => (_ctx.handlePinKeydown($event, index))
                        }, null, 40, _hoisted_16), [
                          [_vModelText, _ctx.passwordDigits[index]]
                        ])
                      }), 64))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            "1": _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", null, _toDisplayString(_ctx.Lang.getI18N("draw-pattern")), 1),
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (point) => {
                    return _createElementVNode("div", {
                      key: point - 1,
                      class: _normalizeClass([
                  'pattern-point',
                  _ctx.patternPoints.includes(point - 1) ? 'selected' : '',
                ]),
                      onClick: ($event: any) => (_ctx.togglePatternPoint(point - 1))
                    }, [
                      (_ctx.patternPoints.includes(point - 1))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.patternPoints.indexOf(point - 1) + 1), 1))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_19)
                  }), 64))
                ]),
                _createVNode(_component_SeButton, { onClick: _ctx.clearPattern }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("clear")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["tabs", "onTabChange"]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_SeButton, { onClick: _ctx.closeAuthModal }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_SeButton, { onClick: _ctx.saveAuthSettings }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("save")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}